<template>
  <div class="container-xl px-4 products-price-page">
    <!-- Título. El alta de productos vive en el módulo de Productos: esta
         pantalla es solo de precios. -->
    <div class="row" v-if="!hideHeader">
      <div class="col-12">
        <div class="page-header-mobile d-flex justify-content-between align-items-center mb-3 mt-2">
          <h2 class="fw-bold mb-0 page-title-mobile">{{ selectorMode ? 'Seleccionar Producto' : 'Gestión Precios de Productos' }}</h2>
        </div>
      </div>
    </div>

    <!-- Buscador y filtro por categoría (como en ProductosView.vue) -->
    <div class="row">
      <div class="col-12">
        <div class="card p-3 mobile-filter-card">
          <div class="mobile-context-chip d-lg-none">
            <span class="mobile-context-label">Catálogo e Inventario</span>
            <strong>Precios</strong>
          </div>
          <div class="d-flex justify-content-between align-items-center mb-0 gap-2 flex-wrap mobile-filter-wrap">
            <div class="d-flex gap-2 flex-grow-1 mobile-filter-main" style="min-width: 0;">
              <input
                v-model="searchTerm"
                type="text"
                class="form-control form-control-sm mobile-search-input"
                :placeholder="searchPlaceholder"
              />

              <!-- Select con búsqueda para categorías -->
              <div class="position-relative mobile-category-picker">
                <input
                  v-model="categorySearchTerm"
                  type="text"
                  class="form-control form-control-sm"
                  placeholder="Filtrar por categoría..."
                  @focus="showCategoryDropdown = true"
                  @blur="handleCategoryBlur"
                  :disabled="loadingCategories"
                />

                <!-- Dropdown de categorías -->
                <div
                  v-if="showCategoryDropdown && filteredCategories.length > 0"
                  class="category-dropdown position-absolute w-100 mt-1 bg-white border rounded shadow-sm"
                  style="max-height: 300px; overflow-y: auto; z-index: 1000;"
                >
                  <div
                    class="dropdown-item cursor-pointer px-3 py-2 hover-bg-light"
                    @mousedown.prevent="selectCategory('', 'Todas las categorías')"
                  >
                    <strong>Todas las categorías</strong>
                  </div>
                  <div
                    v-for="cat in filteredCategories"
                    :key="cat.id"
                    class="dropdown-item cursor-pointer px-3 py-2 hover-bg-light"
                    @mousedown.prevent="selectCategory(cat.id, cat.name)"
                  >
                    {{ cat.name }}
                  </div>
                </div>
              </div>
              <div v-if="selectorMode && !onlyBulkProducts" class="d-flex align-items-center gap-1 flex-wrap mobile-price-filter">
                <button
                  type="button"
                  class="btn btn-sm"
                  :class="sourceFilter === 'all' ? 'btn-dark' : 'btn-outline-dark'"
                  @click="setSourceFilter('all')"
                >
                  Todos
                </button>
                <button
                  type="button"
                  class="btn btn-sm"
                  :class="sourceFilter === 'products' ? 'btn-dark' : 'btn-outline-dark'"
                  @click="setSourceFilter('products')"
                >
                  Productos
                </button>
                <button
                  type="button"
                  class="btn btn-sm"
                  :class="sourceFilter === 'presentations' ? 'btn-dark' : 'btn-outline-dark'"
                  @click="setSourceFilter('presentations')"
                >
                  Presentaciones
                </button>
              </div>
              <div class="d-flex align-items-center gap-1 flex-wrap mobile-price-filter">
                <button
                  type="button"
                  class="btn btn-sm"
                  :class="priceFilter === 'true' ? 'btn-success' : 'btn-outline-success'"
                  @click="setPriceFilter('true')"
                >
                  Con precio
                </button>
                <button
                  type="button"
                  class="btn btn-sm"
                  :class="priceFilter === 'false' ? 'btn-danger' : 'btn-outline-danger'"
                  @click="setPriceFilter('false')"
                >
                  Sin precio
                </button>
              </div>
              <div v-if="selectorMode" class="d-flex align-items-center gap-1 flex-wrap mobile-price-filter">
                <button
                  type="button"
                  class="btn btn-sm"
                  :class="stockFilter === 'true' ? 'btn-primary' : 'btn-outline-primary'"
                  @click="setStockFilter('true')"
                >
                  Con stock
                </button>
                <button
                  type="button"
                  class="btn btn-sm"
                  :class="stockFilter === 'false' ? 'btn-secondary' : 'btn-outline-secondary'"
                  @click="setStockFilter('false')"
                >
                  Sin stock
                </button>
              </div>
            </div>
            <button 
              class="btn btn-outline-danger btn-sm d-flex align-items-center flex-shrink-0 mobile-clear-btn"
              @click="clearFilters"
              :disabled="!searchTerm && !selectedCategory && priceFilter === defaultPriceFilter && stockFilter === defaultStockFilter && sourceFilter === 'all'"
            >
              <i class="bi bi-arrow-counterclockwise me-1"></i> 
              Limpiar
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="mobile-results-summary d-lg-none">
      <div class="mobile-results-pill">
        <span class="mobile-results-value">{{ pagedProducts.length }}</span>
        <span class="mobile-results-copy">ítems visibles</span>
      </div>
      <div v-if="selectedCategoryName" class="mobile-results-pill secondary">
        <span class="mobile-results-copy">Categoría</span>
        <span class="mobile-results-value small">{{ selectedCategoryName }}</span>
      </div>
      <div v-if="!selectorMode && priceFilter !== 'all'" class="mobile-results-pill secondary">
        <span class="mobile-results-copy">Filtro</span>
        <span class="mobile-results-value small">{{ priceFilter === 'true' ? 'Con precio' : 'Sin precio' }}</span>
      </div>
    </div>

    <!-- Tabla desktop -->
    <div class="bg-white rounded shadow-sm p-2 d-none d-lg-block">
      <div class="table-responsive">
        <table class="table align-middle">
          <thead class="table-light">
            <tr>
                  <th class="col-barcode">Código de barras</th>
                  <th class="col-nombre">Nombre</th>
              <th class="text-end col-price-compra">Precio última compra</th>
              <th class="col-categoria">Categoría</th>
                  <th class="text-end col-stock">Stock disponible</th>
              <th class="text-end col-price">Precio de Venta</th>
              <th v-if="!selectorMode" class="text-end col-actions">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="!loading && pagedProducts.length === 0">
              <td :colspan="selectorMode ? 6 : 7" class="text-center text-muted py-4">
                No hay productos ni presentaciones para los filtros actuales.
              </td>
            </tr>
            <tr
              v-else
              v-for="prod in pagedProducts"
              :key="prod._key || prod.producto_id"
              :class="{ 'selectable-row': selectorMode }"
              @click="selectorMode && seleccionarProducto(prod)"
            >
                  <td class="col-barcode">{{ prod.codigo_barras || prod.codigo_producto || 'Sin código' }}</td>
                  <td class="col-nombre">
                    <div>{{ prod.nombre }}</div>
                    <span v-if="prod.es_presentacion" class="badge bg-info-subtle text-info-emphasis">Presentación</span>
                    <span v-else-if="prod.es_componente_presentacion" class="badge bg-success-subtle text-success-emphasis">Producto componente</span>
                    <small v-if="prod.es_componente_presentacion" class="text-muted d-block">
                      Relacionado con {{ prod.presentacion_relacionada_nombre }} · descuenta unidad operativa
                    </small>
                    <small v-if="prod.estado_producto && prod.estado_producto !== 'Disponible para venta'" class="text-muted d-block">{{ prod.estado_producto }}</small>
                  </td>
              <td class="text-end col-price-compra">{{ prod.precio_ultima_compra ? formateaNumero(prod.precio_ultima_compra) : (prod.es_presentacion ? 'Componentes' : 'Sin precio') }}</td>
              <td class="col-categoria">{{ prod.categoria }}</td>
                  <td class="text-end col-stock">{{ formateaNumero(prod.stock_disponible) }}</td>
              <td class="text-end col-price">{{ formatPriceLabel(prod.precio_venta, prod.es_granel) }}</td>
              <td v-if="!selectorMode" class="text-end col-actions">
                <!-- Única acción de la pantalla. El ABM del producto se hace en
                     Productos: ofrecerlo también acá era la fuente real de la
                     confusión entre "editar precio" y "editar producto". -->
                <div class="d-inline-flex flex-nowrap gap-1 actions-wrapper">
                  <button class="btn btn-success btn-sm px-2 py-1" @click="openPriceModal(prod)" title="Establecer precio de venta">$ Precio</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- paginación -->
      <AppPagination
        class="mt-2"
        :total-pages="totalPages"
        :current-page="currentPage"
        @page-changed="changePage"
      />
    </div>

    <!-- Cards mobile -->
    <div class="mobile-product-list d-lg-none">
      <div v-if="!loading && pagedProducts.length === 0" class="mobile-empty-state text-center text-muted py-4">
        No hay productos ni presentaciones para los filtros actuales.
      </div>
      <div
        v-else
        v-for="prod in pagedProducts"
        :key="`mobile-${prod._key || prod.producto_id}`"
        class="mobile-product-card"
        :class="{ 'selectable-row': selectorMode }"
        @click="selectorMode && seleccionarProducto(prod)"
      >
        <div class="mobile-product-top">
          <div>
            <p class="mobile-product-code">{{ prod.codigo_barras || prod.codigo_producto || 'Sin código' }}</p>
            <h3 class="mobile-product-name">{{ prod.nombre }}</h3>
            <span v-if="prod.es_presentacion" class="badge bg-info-subtle text-info-emphasis">Presentación</span>
            <span v-else-if="prod.es_componente_presentacion" class="badge bg-success-subtle text-success-emphasis">Producto componente</span>
            <small v-if="prod.es_componente_presentacion" class="text-muted d-block">
              Relacionado con {{ prod.presentacion_relacionada_nombre }}
            </small>
          </div>
          <span class="mobile-price-badge" :class="{ empty: !prod.precio_venta }">
            {{ formatPriceLabel(prod.precio_venta, prod.es_granel) }}
          </span>
        </div>

        <div class="mobile-product-meta">
          <div class="mobile-meta-item">
            <span class="mobile-meta-label">Categoría</span>
            <strong>{{ prod.categoria || 'Sin categoría' }}</strong>
          </div>
          <div class="mobile-meta-item">
            <span class="mobile-meta-label">Stock</span>
            <strong>{{ formateaNumero(prod.stock_disponible) }}</strong>
          </div>
          <div class="mobile-meta-item">
            <span class="mobile-meta-label">Última compra</span>
            <strong>{{ prod.precio_ultima_compra ? formateaNumero(prod.precio_ultima_compra) : 'Sin precio' }}</strong>
          </div>
        </div>

        <div v-if="!selectorMode" class="mobile-product-actions">
          <button class="btn btn-success btn-sm" @click.stop="openPriceModal(prod)">
            Actualizar precio
          </button>
        </div>
      </div>

      <AppPagination
        class="mt-3"
        :total-pages="totalPages"
        :current-page="currentPage"
        @page-changed="changePage"
      />
    </div>

    <div
      class="modal fade"
      id="updatePriceModal"
      tabindex="-1"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Actualizar Precio</h5>
            <button type="button" class="btn-close" @click="closePriceModal"/>
          </div>
          <div class="modal-body">
            <form @submit.prevent="updatePrice">
              <div class="container-fluid">
                <div class="price-modal-summary">
                  <p class="price-modal-eyebrow">Producto seleccionado</p>
                  <h6 class="price-modal-name">{{ modalData.productName || 'Producto' }}</h6>
                  <div class="price-quick-actions">
                    <button type="button" class="btn btn-outline-secondary btn-sm" @click="applyQuickIncrease(5)">+5%</button>
                    <button type="button" class="btn btn-outline-secondary btn-sm" @click="applyQuickIncrease(10)">+10%</button>
                    <button type="button" class="btn btn-outline-secondary btn-sm" @click="restoreCurrentPrice">Precio actual</button>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-md-4">
                    <label for="cantidadDesde" class="form-label">
                      {{ modalData.isBulk ? 'Cantidad desde (kg)' : 'Cantidad desde' }}
                    </label>
                    <input
                      type="number"
                      id="cantidadDesde"
                      class="form-control"
                      v-model.number="modalData.cantidadDesde"
                      min="1"
                      :step="modalData.isBulk ? '0.001' : '1'"
                      required
                    />
                    <small v-if="modalData.isBulk" class="text-muted d-block mt-1">
                      Precio comercial por kilogramo. El sistema convierte internamente a gramos.
                    </small>
                  </div>
                  <div class="col-md-6">
                    <label for="newPrice" class="form-label">
                      {{ modalData.isBulk ? 'Nuevo Precio por kg' : 'Nuevo Precio' }}
                    </label>
                    <MoneyInput
                      input-id="newPrice"
                      v-model="modalData.nuevoPrecio"
                      placeholder="0"
                    />
                  </div>
                  <div class="col-md-4">
                    <label for="vigencia" class="form-label">Fecha de Vigencia</label>
                    <input
                      ref="vigenciaInput"
                      type="text"
                      id="vigencia"
                      class="form-control"
                      v-model="modalData.fechaVigencia"
                      placeholder="dd/mm/aaaa"
                      autocomplete="off"
                      required
                    />
                  </div>
                </div>
                <div v-if="modalData.rangos.length" class="row mb-3">
                  <div class="col-12">
                    <label class="form-label">Rangos vigentes</label>
                    <div class="table-responsive border rounded">
                      <table class="table table-sm align-middle mb-0">
                        <thead class="table-light">
                          <tr>
                            <th>Cantidad</th>
                            <th class="text-end">Precio</th>
                            <th>Vigencia desde</th>
                            <th class="text-end">Acciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="rango in modalData.rangos" :key="`${rango.cantidad_desde}-${rango.vigencia_desde || 'actual'}`">
                            <td>
                              {{ formatRangeQuantity(rango, modalData.isBulk) }}
                              <span v-if="rango.cantidad_hasta != null"> - {{ formatRangeUpperBound(rango, modalData.isBulk) }}</span>
                              <span v-else> en adelante</span>
                            </td>
                            <td class="text-end">{{ formatPriceLabel(rango.precio_venta, modalData.isBulk) }}</td>
                            <td>{{ formatDateDisplay(rango.vigencia_desde) }}</td>
                            <td class="text-end text-nowrap">
                              <button
                                type="button"
                                class="btn btn-outline-primary btn-sm me-1"
                                @click="editPriceRange(rango)"
                              >
                                Editar
                              </button>
                              <button
                                type="button"
                                class="btn btn-outline-danger btn-sm"
                                :disabled="Number(rango.cantidad_desde) === 1 || modalData.programados.length > 0"
                                @click="deletePriceRange(rango)"
                              >
                                Eliminar
                              </button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <small class="text-muted">El rango que inicia en 1 no se puede eliminar.</small>
                  </div>
                </div>
                <div v-if="modalData.programados.length" class="row mb-3">
                  <div class="col-12">
                    <label class="form-label">Precios programados</label>
                    <div class="table-responsive border rounded">
                      <table class="table table-sm align-middle mb-0">
                        <thead class="table-light">
                          <tr>
                            <th>Cantidad</th>
                            <th class="text-end">Precio</th>
                            <th>Rige desde</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="rango in modalData.programados" :key="`prog-${rango.cantidad_desde}-${rango.vigencia_desde}`">
                            <td>
                              {{ formatRangeQuantity(rango, modalData.isBulk) }}
                              <span v-if="rango.cantidad_hasta != null"> - {{ formatRangeUpperBound(rango, modalData.isBulk) }}</span>
                              <span v-else> en adelante</span>
                            </td>
                            <td class="text-end">{{ formatPriceLabel(rango.precio_venta, modalData.isBulk) }}</td>
                            <td>{{ formatDateDisplay(rango.vigencia_desde) }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <small class="text-muted">Mientras haya precios programados se pueden cambiar precios, pero no crear ni eliminar tramos.</small>
                  </div>
                </div>
                <div class="price-modal-footer-actions">
                  <div class="text-end">
                    <button type="submit" class="btn btn-success price-save-btn">
                      Guardar Cambios
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import AppPagination     from '../../components/AppPagination.vue'; // Importa la paginación
import MoneyInput        from '../../components/MoneyInput.vue';
import apiService        from '../../services/apiService.js'; // Importa el servicio API
                  // 
import * as bootstrap    from 'bootstrap';                                    // 
import flatpickr         from 'flatpickr';
import 'flatpickr/dist/flatpickr.css';
import { Spanish }       from 'flatpickr/dist/l10n/es.js';

const DISPLAY_DATE_FORMAT = 'd/m/Y';
// Espera desde la última letra antes de buscar (antes 500 ms: ~88 % del tiempo
// visible, pos-graciela-api/docs/MEDICION_BUSQUEDA_LINEA_BASE_2026-10-24.md).
const ESPERA_BUSQUEDA_MS = 250;

export default {
  name: 'ProductosView',                                                      // 
  components: {
    AppPagination,
    MoneyInput
  },

  props: {
    selectorMode: { type: Boolean, default: false },
    hideHeader:   { type: Boolean, default: false },
    onlyBulkProducts: { type: Boolean, default: false },
    initialSearch: { type: String, default: '' }
  },

  data() {
    return {
      // Productos y paginación
      products: [],
      presentations: [],
      relatedComponentItems: [],
      currentPage: 1,
      totalPages: 1,
      pagination: {},
      itemsPerPage: 10,
      loading: false,

      // Filtros
      searchTerm: '',
      categorySearchTerm: '',
      showCategoryDropdown: false,
      selectedCategory: '', // ID
      selectedCategoryName: '',
      categories: [],
      allCategories: [],
      loadingCategories: false,

      // Filtros de disponibilidad del selector
      priceFilter: 'all',
      stockFilter: 'all',
      sourceFilter: 'all',
      usingLocalPagination: false,

      priceModalFocusBound: false,
      // Modal de precio
      priceModalInstance: null,
      vigenciaPicker: null,

      // Estructura de datos para precio
      modalData: {
        productId:    null,
        productName: '',
        currentPrice: 0,
        isBulk: false,
        cantidadDesde: 1,
        nuevoPrecio:  0,
        fechaVigencia: this.formatDateDisplay(new Date()),
        rangos: [],
        programados: []
      }
    };
  },

  computed: {
    // Filtra categorías por texto
    filteredCategories() {
      if (!this.categorySearchTerm.trim()) return this.allCategories
      const term = this.categorySearchTerm.toLowerCase()
      return this.allCategories.filter(cat => cat.name.toLowerCase().includes(term))
    },

    // La lista a mostrar (paginada por el servidor)
    pagedProducts() {
      const list = this.filteredItems
      if (!this.usingLocalPagination) return list
      const start = (this.currentPage - 1) * this.itemsPerPage
      return list.slice(start, start + this.itemsPerPage)
    },

    filteredItems() {
      const productList = Array.isArray(this.products) ? this.products : []
      const presentationList = Array.isArray(this.presentations) ? this.presentations : []
      const relatedComponentList = Array.isArray(this.relatedComponentItems) ? this.relatedComponentItems : []
      const relatedComponentProductIds = new Set(relatedComponentList.map((item) => Number(item.producto_id)))
      const visibleProducts = this.selectorMode
        ? productList.filter((item) => !relatedComponentProductIds.has(Number(item.producto_id)))
        : productList
      let list = this.selectorMode ? [...presentationList, ...relatedComponentList, ...visibleProducts] : visibleProducts

      if (this.onlyBulkProducts) {
        list = list.filter((item) => item.es_granel)
      } else if (this.selectorMode) {
        list = list.filter((item) => !item.es_granel)
      }

      if (this.selectorMode && !this.onlyBulkProducts && this.sourceFilter !== 'all') {
        list = list.filter((item) => this.sourceFilter === 'presentations'
          ? item.es_presentacion
          : !item.es_presentacion)
      }

      if (this.selectorMode && this.selectedCategory) {
        list = list.filter((item) => String(item.categoria_id || '') === String(this.selectedCategory))
      }

      if (this.selectorMode && this.priceFilter !== 'all') {
        const expected = this.priceFilter === 'true'
        list = list.filter((item) => Boolean(item.tiene_precio) === expected)
      }

      if (this.selectorMode && this.stockFilter !== 'all') {
        const expected = this.stockFilter === 'true'
        list = list.filter((item) => Boolean(item.tiene_stock) === expected)
      }

      return list
    },

    defaultPriceFilter() {
      return this.selectorMode ? 'true' : 'all'
    },

    defaultStockFilter() {
      return this.selectorMode ? 'true' : 'all'
    },

    searchPlaceholder() {
      if (this.onlyBulkProducts) {
        return 'Buscar producto granel por nombre, código o PLU...'
      }
      return 'Buscar por nombre...'
    }
  },

  methods: {
    seleccionarProducto(prod) {
      this.$emit('producto-seleccionado', prod)
    },

    normalizeLookupValue(value) {
      return String(value || '').trim().toLowerCase()
    },

    presentationMatchesSearch(presentation) {
      const term = this.normalizeLookupValue(this.searchTerm)
      if (!term) return false
      return [
        presentation.codigo_barras,
        presentation.sku_presentacion,
        presentation.nombre
      ].some((value) => this.normalizeLookupValue(value) === term)
    },

    formatCommercialQuantity(value, isBulk) {
      const numeric = Number(value)
      if (!Number.isFinite(numeric) || numeric <= 0) return ''
      if (!isBulk) return this.formateaNumero(numeric)

      const kilos = numeric / 1000
      return kilos % 1 === 0
        ? this.formateaNumero(kilos)
        : kilos.toLocaleString('es-PY', { minimumFractionDigits: 0, maximumFractionDigits: 3 })
    },

    formatRangeQuantity(range, isBulk) {
      const quantity = isBulk && range?.cantidad_desde_kg != null
        ? Number(range.cantidad_desde_kg) * 1000
        : range?.cantidad_desde
      const base = this.formatCommercialQuantity(quantity, isBulk)
      return isBulk && base ? `${base} kg` : base
    },

    formatRangeUpperBound(range, isBulk) {
      const quantity = isBulk && range?.cantidad_hasta_kg != null
        ? Number(range.cantidad_hasta_kg) * 1000
        : range?.cantidad_hasta
      const base = this.formatCommercialQuantity(quantity, isBulk)
      return isBulk && base ? `${base} kg` : base
    },

    formatPriceLabel(price, isBulk) {
      const numeric = Number(price)
      if (!Number.isFinite(numeric) || numeric <= 0) return 'Sin precio'
      return isBulk ? `${this.formateaNumero(numeric)}/kg` : this.formateaNumero(numeric)
    },

    parseRangeStartInput(value, isBulk) {
      const numeric = Number(value)
      if (!Number.isFinite(numeric) || numeric <= 0) return null
      if (!isBulk) {
        return Number.isInteger(numeric) ? numeric : null
      }

      const grams = Math.round(numeric * 1000)
      return Number.isInteger(grams) && grams > 0 ? grams : null
    },

    // Mapea un producto del backend al formato de la vista
    mapProduct(item) {
      const pickCurrentPrice = (arr = []) => {
        if (!Array.isArray(arr) || !arr.length) return null
        const now = new Date()
        const qty = item.es_granel ? 1000 : 1
        let candidates = arr.filter(p => {
          const desde = p?.vigencia_desde ? new Date(p.vigencia_desde) : null
          if (!desde || isNaN(desde.getTime())) return false
          const hasta = p?.vigencia_hasta ? new Date(p.vigencia_hasta) : null
          const inDate = desde <= now && (!hasta || hasta >= now)
          const cantidadOK = (p.cantidad_desde == null || p.cantidad_desde <= qty) && (p.cantidad_hasta == null || p.cantidad_hasta >= qty)
          return inDate && cantidadOK
        })
        if (!candidates.length) candidates = [...arr]
        candidates.sort((a,b) => new Date(b.vigencia_desde) - new Date(a.vigencia_desde))
        return candidates[0] || null
      }

      const priceRec = pickCurrentPrice(item.precios_vigentes || [])
      const precioVentaNum = priceRec ? Number(priceRec.precio_venta) : null

      return {
        _key: `producto-${item.producto_id}`,
        es_presentacion: false,
        producto_id: item.producto_id,
        codigo_barras: item.codigo_barras || '',
        nombre: item.nombre || '',
        descripcion: item.descripcion || '',
        stock_disponible: item.stock_disponible ?? 0,
        categoria: item.categoria || item.categoria_nombre || '',
        categoria_id: item.categoria_id,
        unidad_medida: item.unidad_medida || item.unidad_medida_nombre || '',
        unidad_medida_id: item.unidad_medida_id,
        precio_venta: (Number.isFinite(precioVentaNum) && precioVentaNum > 0) ? precioVentaNum : null,
        tiene_precio: item.disponibilidad?.tiene_precio ?? ((Number.isFinite(precioVentaNum) && precioVentaNum > 0) || Number(item.precio_unitario_resuelto) > 0),
        tiene_stock: item.disponibilidad?.tiene_stock ?? Number(item.stock_disponible) > 0,
        estado_producto: item.estado_producto || item.disponibilidad?.mensaje || '',
        precio_ultima_compra: item.precio_ultima_compra ?? null,
        vigencia_desde: priceRec?.vigencia_desde || null,
        vigencia_hasta: priceRec?.vigencia_hasta || null,
        _precios_vigentes: item.precios_vigentes || [],
        codigo_producto: item.codigo_producto || '',
        codigo_plu_balanza: item.codigo_plu_balanza || '',
        es_granel: Boolean(item.es_granel),
        activo: item.activo,
        tipo_iva: item.tipo_iva,
        url_imagen: item.url_imagen || ''
      }
    },

    mapPresentation(item) {
      return {
        _key: `presentacion-${item.presentacion_id}`,
        es_presentacion: true,
        presentacion_id: item.presentacion_id,
        producto_id: null,
        codigo_barras: item.codigo_barras || item.sku_presentacion || '',
        codigo_producto: item.sku_presentacion || item.codigo_barras || '',
        sku_presentacion: item.sku_presentacion || '',
        nombre: item.nombre || '',
        descripcion: item.descripcion || '',
        stock_disponible: Number(item.stock_disponible_presentaciones) || 0,
        categoria: item.categoria_nombre || 'Presentación',
        categoria_id: item.categoria_id || null,
        unidad_medida: 'presentación',
        unidad_medida_id: null,
        precio_venta: Number(item.precio_venta_actual) > 0 ? Number(item.precio_venta_actual) : null,
        precio_ultima_compra: null,
        codigo_plu_balanza: '',
        es_granel: false,
        activo: item.activa !== false,
        tipo_iva: null,
        url_imagen: '',
        tiene_precio: Boolean(item.tiene_precio),
        tiene_stock: Boolean(item.tiene_stock),
        estado_producto: item.estado_venta || '',
        politica_precio: item.politica_precio || null
      }
    },

    mapRelatedComponentItem(product, presentation, component) {
      const mapped = this.mapProduct(product)
      return {
        ...mapped,
        _key: `presentacion-${presentation.presentacion_id}-componente-${component.producto_id}`,
        es_componente_presentacion: true,
        presentacion_relacionada_id: presentation.presentacion_id,
        presentacion_relacionada_nombre: presentation.nombre || '',
        presentacion_relacionada_codigo: presentation.codigo_barras || presentation.sku_presentacion || '',
        cantidad_en_presentacion: Number(component.cantidad_operativa) || null,
        estado_producto: mapped.estado_producto || 'Disponible para venta'
      }
    },

    async buildRelatedComponentItems(presentations = []) {
      if (!this.selectorMode || !this.searchTerm.trim()) return []

      const exactPresentations = presentations.filter((presentation) => this.presentationMatchesSearch(presentation))
      if (!exactPresentations.length) return []

      const components = []
      const seenProducts = new Set()
      exactPresentations.forEach((presentation) => {
        const presentationComponents = Array.isArray(presentation.componentes) ? presentation.componentes : []
        presentationComponents.forEach((component) => {
          const productId = Number(component.producto_id)
          if (!Number.isInteger(productId) || productId <= 0 || seenProducts.has(productId)) return
          if (Number(component.stock_disponible) <= 0) return
          seenProducts.add(productId)
          components.push({ presentation, component, productId })
        })
      })

      const resolved = await Promise.all(components.map(async ({ presentation, component, productId }) => {
        try {
          const { data } = await apiService.get(`/api/prices/${productId}`)
          const product = data?.data || data
          if (!product?.producto_id) return null
          const mapped = this.mapRelatedComponentItem(product, presentation, component)
          if (mapped.es_granel || !mapped.tiene_precio || !mapped.tiene_stock) return null
          return mapped
        } catch (error) {
          console.warn('[ProductosPrecioView] No se pudo validar componente relacionado', {
            productId,
            presentacion_id: presentation.presentacion_id,
            error: error?.message
          })
          return null
        }
      }))

      return resolved.filter(Boolean)
    },

    // Cargar categorías (todas las páginas)
    async loadCategories() {
      this.loadingCategories = true
      try {
        const all = []
        let page = 1
        let hasMore = true
        while (hasMore) {
          const resp = await apiService.get(`/api/categories?page=${page}&limit=50`)
          const payload = resp.data
          let list = []
          let pagination = null
          if (Array.isArray(payload)) {
            list = payload
            hasMore = false
          } else if (payload?.data) {
            if (Array.isArray(payload.data)) {
              list = payload.data
              hasMore = false
            } else if (Array.isArray(payload.data.data)) {
              list = payload.data.data
              pagination = payload.data.pagination
              hasMore = !!pagination?.hasNextPage
            }
          }
          all.push(...list)
          if (!hasMore) break
          page++
          if (page > 10) {
            console.warn('[ProductosPrecioView] Límite de páginas de categorías alcanzado')
            break
          }
        }
        this.allCategories = all.map(c => ({ id: c.categoria_id ?? c.id, name: c.nombre }))
        this.categories = [...this.allCategories]
      } catch (e) {
        console.error('Error cargando categorías:', e)
        this.allCategories = []
        this.categories = []
      } finally {
        this.loadingCategories = false
      }
    },

    selectCategory(categoryId, categoryName = '') {
      this.selectedCategory = categoryId
      this.selectedCategoryName = categoryName
      this.categorySearchTerm = categoryName
      this.showCategoryDropdown = false
      // Reiniciar a la primera página y cargar
      this.currentPage = 1
      this.programarCarga()
    },

    handleCategoryBlur() {
      setTimeout(() => { this.showCategoryDropdown = false }, 200)
    },

    // Establecer filtro de precio (toggle entre 'true' | 'false' | 'all')
    setPriceFilter(val) {
      this.priceFilter = (this.priceFilter === val) ? 'all' : val
    },

    setStockFilter(val) {
      this.stockFilter = (this.stockFilter === val) ? 'all' : val
    },

    setSourceFilter(val) {
      this.sourceFilter = val
      this.currentPage = 1
      this.programarCarga()
    },

    // Cargar productos con filtros desde el backend
    // Una sola carga por cambio (pos-graciela-api PLAN_BUSQUEDA_PRODUCTOS_v0.3
    // D29): los cambios que llegan juntos (abrir el selector, «Limpiar», elegir
    // categoría) se juntan en una carga, y al tipear se espera ESPERA_BUSQUEDA_MS
    // desde la última letra. Antes cada filtro disparaba la suya (hasta 5).
    // Una carga inmediata pendiente no se aplaza: al abrir el selector con
    // texto precargado, el watcher del texto no debe sumarle la espera de tipeo.
    // La carga lee los filtros al ejecutarse, así que incluye todo lo cambiado.
    programarCarga({ page = 1, espera = 0 } = {}) {
      if (this._cargaProgramada && this._cargaInmediata && espera > 0) return
      if (this._cargaProgramada) clearTimeout(this._cargaProgramada)
      this._cargaInmediata = espera === 0
      this._cargaProgramada = setTimeout(() => {
        this._cargaProgramada = null
        this.loadProducts({ suppressAlert: true, page })
      }, espera)
    },

    async loadProducts(options = {}) {
      const { suppressAlert = false, page = 1 } = options || {}
      // Sólo la última carga pinta: una respuesta atrasada no pisa a la nueva.
      const cargaId = (this._cargaId || 0) + 1
      this._cargaId = cargaId
      const vigente = () => this._cargaId === cargaId
      this.loading = true
      try {
        const requestPage = this.selectorMode ? 1 : page
        let url = `/api/prices?page=${requestPage}`
        if (this.selectorMode) {
          // RN-BP1: al vender sólo se ofrecen productos activos.
          url += '&limit=100&para_venta=1'
        }
        if (this.searchTerm.trim()) {
          // tolerante=1: el API corrige errores de tipeo («cmento») si la
          // búsqueda no trae nada (SPEC_BUSQUEDA_PRODUCTOS_v0.2 del API, RB-12).
          // El ingreso por código (saleResolverService) no lo manda a propósito.
          url += `&search=${encodeURIComponent(this.searchTerm)}&tolerante=1`
        }
        if (this.selectedCategory) {
          url += `&category_id=${this.selectedCategory}`
        }
        if (this.priceFilter !== 'all') {
          url += `&hasPrices=${this.priceFilter}`
        }
        if (this.selectorMode && this.stockFilter !== 'all') {
          url += `&hasStock=${this.stockFilter}`
        }

        const [response, presentationsResponse] = await Promise.all([
          apiService.get(url),
          this.selectorMode
            ? apiService.get('/api/product-presentations', {
              search: this.searchTerm.trim(),
              includeInactive: false
            })
            : Promise.resolve({ data: { data: [] } })
        ])

        if (!vigente()) return
        // Manejar ambos formatos: array directo o { data, pagination }
        const raw = response.data
        const list = Array.isArray(raw) ? raw : (Array.isArray(raw?.data) ? raw.data : [])
        this.products = list.map(this.mapProduct)
        const rawPresentations = presentationsResponse.data?.data ?? presentationsResponse.data
        const salePresentations = Array.isArray(rawPresentations)
          ? rawPresentations.filter((item) => item.es_presentacion_venta !== false)
          : []
        this.presentations = salePresentations.map(this.mapPresentation)
        const relatedComponentItems = await this.buildRelatedComponentItems(salePresentations)
        if (!vigente()) return
        this.relatedComponentItems = relatedComponentItems

        if (this.selectorMode) {
          this.usingLocalPagination = true
          const totalItems = this.filteredItems.length
          this.totalPages = Math.ceil(totalItems / this.itemsPerPage) || 1
          this.currentPage = Math.min(page, this.totalPages)
        } else if (raw?.pagination) {
          this.usingLocalPagination = false
          this.pagination = raw.pagination
          this.totalPages = raw.pagination.totalPages || 1
          this.currentPage = raw.pagination.page || 1
        } else {
          // Sin paginación desde el servidor: una sola página
          this.usingLocalPagination = false
          this.totalPages = 1
          this.currentPage = 1
        }
      } catch (error) {
        if (!vigente()) return
        console.error('Error cargando productos:', error)
        if (!suppressAlert) alert('Error al cargar los productos. Revise la consola.')
        this.products = []
        this.presentations = []
        this.relatedComponentItems = []
        this.totalPages = 1
        this.currentPage = 1
        this.usingLocalPagination = false
      } finally {
        if (vigente()) this.loading = false
      }
    },

    /* ---------- Precio ---------- */
    async openPriceModal(product) {
      this.modalData.productId     = product.producto_id;
      this.modalData.productName   = product.nombre || '';
      this.modalData.currentPrice  = product.precio_venta ?? 0;
      this.modalData.isBulk = Boolean(product.es_granel);
      this.modalData.cantidadDesde = 1;
      this.modalData.nuevoPrecio   = product.precio_venta ?? 0;
      this.modalData.fechaVigencia = this.formatDateDisplay(new Date());
      this.modalData.rangos = this.normalizePriceRanges(product._precios_vigentes || []);
      this.modalData.programados = [];

      await this.reloadModalRanges(product);

      const el = document.getElementById('updatePriceModal');
      this.priceModalInstance ??= new bootstrap.Modal(el, {
        backdrop: 'static',
        keyboard: false
      });

      this.$nextTick(() => {
        this.ensureVigenciaPicker();
        this.syncVigenciaPicker();
        // El foco se pide en `shown.bs.modal`, no acá: durante la transición
        // de apertura Bootstrap mueve el foco por su cuenta y pedirlo antes es
        // una carrera que a veces se pierde (RF-6 del SPEC).
        if (!this.priceModalFocusBound) {
          el.addEventListener('shown.bs.modal', () => {
            const input = document.getElementById('newPrice');
            input?.focus?.();
            input?.select?.();
          });
          this.priceModalFocusBound = true;
        }
        this.priceModalInstance.show();
      });
    },
    closePriceModal() { this.priceModalInstance?.hide(); },
    // SPEC_ESQUEMA_PRECIOS_v0.1.md RN-10: los tramos salen de
    // GET /api/prices/:id (`precios_vigentes`, `precios_programados`). El API
    // responde 404 con los mismos campos cuando el producto no tiene precio.
    async reloadModalRanges(product = null) {
      const productId = product?.producto_id ?? this.modalData.productId;
      try {
        const { data } = await apiService.get(`/api/prices/${productId}`);
        this.applyModalRanges(data, product);
      } catch (error) {
        const data = error?.response?.data;
        if (error?.response?.status === 404 && Array.isArray(data?.precios_vigentes)) {
          this.applyModalRanges(data, product);
          return;
        }
        console.error('Error cargando rangos de precio:', error);
      }
    },
    applyModalRanges(data, product) {
      this.modalData.isBulk = Boolean(data?.es_granel ?? product?.es_granel ?? this.modalData.isBulk);
      this.modalData.rangos = this.normalizePriceRanges(data?.precios_vigentes || []);
      this.modalData.programados = Array.isArray(data?.precios_programados)
        ? data.precios_programados.map((range) => ({
          ...range,
          cantidad_desde: Number(range.cantidad_desde),
          cantidad_hasta: range.cantidad_hasta == null ? null : Number(range.cantidad_hasta),
          precio_venta: Number(range.precio_venta)
        }))
        : [];
    },
    editPriceRange(rango) {
      this.modalData.cantidadDesde = this.modalData.isBulk
        ? (Number(rango.cantidad_desde) === 1 ? 1 : Number(rango.cantidad_desde) / 1000)
        : Number(rango.cantidad_desde);
      this.modalData.nuevoPrecio = Number(rango.precio_venta);
      this.$nextTick(() => {
        const input = document.getElementById('newPrice');
        input?.focus?.();
        input?.select?.();
      });
    },
    apiErrorMessage(error, fallback) {
      const data = error?.response?.data;
      return data?.message || (typeof data?.error === 'string' ? data.error : null) || fallback;
    },
    // RN-17 / D-1: con el modelo "todas las unidades" bajar el precio en un
    // umbral hace que las cantidades justo debajo cuesten más que el umbral.
    // Se avisa; no se bloquea.
    detectarAcantilados(rangos, isBulk) {
      const fmt = (cantidad) => (isBulk
        ? `${(cantidad / 1000).toLocaleString('es-PY', { maximumFractionDigits: 3 })} kg`
        : `${this.formateaNumero(cantidad)} u.`);
      const avisos = [];
      for (let i = 1; i < rangos.length; i++) {
        const umbral = Number(rangos[i].cantidad_desde);
        const precio = Number(rangos[i].precio_venta);
        const precioAnterior = Number(rangos[i - 1].precio_venta);
        if (!(precio > 0) || !(precio < precioAnterior)) continue;
        const desde = Math.floor((umbral * precio) / precioAnterior) + 1;
        if (desde <= umbral - 1) {
          avisos.push(`de ${fmt(desde)} a ${fmt(umbral - 1)} cuesta más que llevar ${fmt(umbral)}`);
        }
      }
      return avisos;
    },
    simularRangos({ cantidadDesdePersistida, precioVenta, isBulk }) {
      const rangos = this.modalData.rangos.map((rango) => ({ ...rango }));
      const esBaseGranel = isBulk && Number(cantidadDesdePersistida) === 1000
        && rangos.length && Number(rangos[0].cantidad_desde) < 1000;
      const objetivo = esBaseGranel
        ? rangos[0]
        : rangos.find((rango) => Number(rango.cantidad_desde) === Number(cantidadDesdePersistida));
      if (objetivo) {
        objetivo.precio_venta = Number(precioVenta);
      } else {
        rangos.push({ cantidad_desde: Number(cantidadDesdePersistida), precio_venta: Number(precioVenta) });
      }
      return rangos.sort((a, b) => a.cantidad_desde - b.cantidad_desde);
    },
    applyQuickIncrease(percent) {
      const base = Number(this.modalData.nuevoPrecio || this.modalData.currentPrice || 0);
      if (!base) return;
      const next = Math.round(base * (1 + (percent / 100)));
      this.modalData.nuevoPrecio = next;
    },
    restoreCurrentPrice() {
      const current = Number(this.modalData.currentPrice || 0);
      this.modalData.nuevoPrecio = current;
    },
    shouldConfirmPriceUpdate(nextPrice, vigenciaISO) {
      const current = Number(this.modalData.currentPrice || 0);
      return current > 0 || vigenciaISO > this.formatDate(new Date()) || Number(nextPrice) !== current;
    },
    confirmPriceUpdate(nextPrice, vigenciaISO) {
      const currentLabel = this.formatPriceLabel(this.modalData.currentPrice, this.modalData.isBulk);
      const nextLabel = this.formatPriceLabel(nextPrice, this.modalData.isBulk);
      const vigenciaLabel = this.formatDateDisplay(`${vigenciaISO}T00:00:00`);
      return window.confirm(
        `Confirmar cambio de precio para “${this.modalData.productName}”.\n\nActual: ${currentLabel}\nNuevo: ${nextLabel}\nVigencia: ${vigenciaLabel}`
      );
    },

    normalizePriceRanges(ranges = []) {
      if (!Array.isArray(ranges)) return [];
      return [...ranges]
        .map((range) => ({
          cantidad_desde: Number(range.cantidad_desde),
          cantidad_hasta: range.cantidad_hasta == null ? null : Number(range.cantidad_hasta),
          precio_venta: Number(range.precio_venta),
          vigencia_desde: range.vigencia_desde || null,
          cantidad_desde_kg: range.cantidad_desde_kg == null ? null : Number(range.cantidad_desde_kg),
          cantidad_hasta_kg: range.cantidad_hasta_kg == null ? null : Number(range.cantidad_hasta_kg)
        }))
        .filter((range) => Number.isInteger(range.cantidad_desde) && range.cantidad_desde > 0)
        .sort((a, b) => a.cantidad_desde - b.cantidad_desde);
    },

    findPriceRangeByStart(cantidadDesde) {
      return (this.modalData.rangos || []).find(
        (range) => Number(range.cantidad_desde) === Number(cantidadDesde)
      ) || null;
    },

    buildPriceSchedulePayload({ vigenciaISO, precioVenta, cantidadDesde, cantidadDesdePersistida, isBulk }) {
      const payload = {
        vigencia_desde: vigenciaISO,
        precio_venta: Number(precioVenta)
      };

      if (isBulk) {
        payload.cantidad_desde_kg = Number(cantidadDesde);
      } else {
        payload.cantidad_desde = Number(cantidadDesdePersistida);
      }

      return payload;
    },

    buildPriceRangePayload({ precioVenta, cantidadDesdePersistida }) {
      return {
        cantidad_desde: Number(cantidadDesdePersistida),
        precio_venta: Number(precioVenta)
      };
    },

    applyLocalPriceRange({ productId, precioVenta, vigenciaISO, cantidadDesdePersistida, existingRange }) {
      const today = this.formatDate(new Date());
      const prod = this.products.find(p => p.producto_id === productId);
      const localRange = {
        ...(existingRange || {}),
        precio_venta: Number(precioVenta),
        vigencia_desde: vigenciaISO,
        vigencia_hasta: null,
        cantidad_desde: Number(cantidadDesdePersistida),
        cantidad_hasta: existingRange?.cantidad_hasta ?? null,
        cantidad_desde_kg: this.modalData.isBulk ? Number(cantidadDesdePersistida) / 1000 : null,
        cantidad_hasta_kg: this.modalData.isBulk && existingRange?.cantidad_hasta != null
          ? Number(existingRange.cantidad_hasta) / 1000
          : null
      };

      if (prod) {
        if (vigenciaISO <= today) {
          prod.precio_venta = Number(precioVenta);
          prod.vigencia_desde = vigenciaISO;
          prod.vigencia_hasta = null;
        }
        if (Array.isArray(prod._precios_vigentes)) {
          prod._precios_vigentes = this.normalizePriceRanges([
            ...prod._precios_vigentes.filter(
              (range) => Number(range.cantidad_desde) !== Number(cantidadDesdePersistida)
            ),
            localRange
          ]);
        }
      }

      this.modalData.rangos = this.normalizePriceRanges([
        ...this.modalData.rangos.filter(
          (range) => Number(range.cantidad_desde) !== Number(cantidadDesdePersistida)
        ),
        localRange
      ]);
    },

    async deletePriceRange(rango) {
      const rangeLabel = this.formatRangeQuantity(rango, this.modalData.isBulk);
      const confirmed = await confirm({
        message: `¿Eliminar el rango desde ${rangeLabel} de “${this.modalData.productName}”?`,
        title: 'Eliminar rango de precio',
        confirmText: 'Eliminar',
        cancelText: 'Cancelar'
      });
      if (!confirmed) return;

      try {
        await apiService.delete(`/api/prices/${this.modalData.productId}/ranges/${rango.cantidad_desde}`);
        this.modalData.rangos = this.modalData.rangos.filter(
          (item) => Number(item.cantidad_desde) !== Number(rango.cantidad_desde)
        );
        await this.loadProducts({ suppressAlert: true, page: this.currentPage });
      } catch (error) {
        console.error('Error eliminando rango de precio:', error);
        alert(this.apiErrorMessage(error, 'Error al eliminar el rango de precio.'));
      }
    },

    async updatePrice() {
        const { productId, nuevoPrecio, fechaVigencia, cantidadDesde, isBulk } = this.modalData;
        if (!productId) {
          console.error('No productId for price update');
          return;
        }
        // El input original tenía `required`; `MoneyInput` no lo replica, así
        // que la validación pasa a ser explícita en vez de depender del
        // navegador. Sin esto, un campo vacío enviaría `null` como precio.
        if (!Number.isFinite(Number(nuevoPrecio)) || Number(nuevoPrecio) <= 0) {
          alert('Ingrese un precio válido mayor a 0.');
          return;
        }
        const cantidadDesdePersistida = this.parseRangeStartInput(cantidadDesde, isBulk);
        if (!cantidadDesdePersistida) {
          alert(isBulk ? 'Ingrese una cantidad válida en kg mayor a 0.' : 'Ingrese una cantidad válida mayor a 0.');
          return;
        }
        // RN-16 / D-5: en granel los tramos mayoristas empiezan en 1 kg o más.
        if (isBulk && cantidadDesdePersistida < 1000) {
          alert('En productos a granel los tramos empiezan en 1 kg o más.');
          return;
        }
        const vigenciaISO = this.convertDisplayToISO(fechaVigencia);
        if (!vigenciaISO) {
          alert('Seleccione una fecha de vigencia válida.');
          return;
        }
        const today = this.formatDate(new Date());
        const existingRange = this.findPriceRangeByStart(cantidadDesdePersistida);
        const canScheduleBaseRange = Number(cantidadDesdePersistida) === 1 || (isBulk && Number(cantidadDesdePersistida) === 1000);
        const shouldCreateRange = !existingRange && !canScheduleBaseRange;

        if (shouldCreateRange && vigenciaISO !== today) {
          alert('Para crear un rango nuevo, use fecha de vigencia de hoy. Las fechas futuras sólo aplican a rangos ya existentes.');
          return;
        }

        const schedulePayload = this.buildPriceSchedulePayload({
          vigenciaISO,
          precioVenta: nuevoPrecio,
          cantidadDesde,
          cantidadDesdePersistida,
          isBulk
        });

        if (this.shouldConfirmPriceUpdate(schedulePayload.precio_venta, vigenciaISO) && !this.confirmPriceUpdate(schedulePayload.precio_venta, vigenciaISO)) {
          return;
        }

        const acantilados = this.detectarAcantilados(
          this.simularRangos({ cantidadDesdePersistida, precioVenta: nuevoPrecio, isBulk }),
          isBulk
        );
        if (acantilados.length && !window.confirm(
          `Atención: con estos tramos ${acantilados.join('; ')}.\n\n¿Guardar igual?`
        )) {
          return;
        }

        const request = shouldCreateRange
          ? apiService.post(
              `/api/prices/${productId}/ranges`,
              this.buildPriceRangePayload({
                precioVenta: nuevoPrecio,
                cantidadDesdePersistida
              })
            )
          : apiService.post(`/api/prices/${productId}/prices/schedule`, schedulePayload);

        try {
          const { data } = await request;
          // Si el backend responde { ok: true } asumimos éxito
          if (data?.ok) {
            // Actualizar cache local (si la vigencia es hoy o pasada adoptamos como precio actual)
            this.applyLocalPriceRange({
              productId,
              precioVenta: nuevoPrecio,
              vigenciaISO,
              cantidadDesdePersistida,
              existingRange
            });
            await this.reloadModalRanges();
            this.closePriceModal();
            this.loadProducts({ suppressAlert: true, page: this.currentPage });
          } else {
            console.warn('Respuesta inesperada al programar precio', data);
          }
        } catch (err) {
          console.error('Error updating price:', err);
          alert(this.apiErrorMessage(
            err,
            shouldCreateRange ? 'Error al crear el rango de precio.' : 'Error al programar el precio.'
          ));
        }
    },

    /* ---------- Otros ---------- */
    changePage(page) {
      if (page < 1 || page > this.totalPages) return
      this.currentPage = page
      if (this.usingLocalPagination) return
      this.loadProducts({ suppressAlert: true, page })
    },

    formatDate(date) {                                                        // ≡
      const d = new Date(date);
      const yyyy = d.getFullYear();
      const mm   = (`0${d.getMonth()+1}`).slice(-2);
      const dd   = (`0${d.getDate()}`).slice(-2);
      return `${yyyy}-${mm}-${dd}`;
    },
    formatDateDisplay(date) {
      // Una vigencia llega como `2026-10-14` o `2026-10-14T00:00:00.000Z`: es
      // una fecha de calendario. Pasarla por `new Date` en UTC-3 la corría al
      // día anterior (SPEC_ESQUEMA_PRECIOS_v0.1.md D-4).
      const iso = typeof date === 'string' ? /^(\d{4})-(\d{2})-(\d{2})/.exec(date) : null;
      if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`;
      const d = new Date(date);
      if (Number.isNaN(d.getTime())) return '';
      const dd = (`0${d.getDate()}`).slice(-2);
      const mm = (`0${d.getMonth()+1}`).slice(-2);
      const yyyy = d.getFullYear();
      return `${dd}/${mm}/${yyyy}`;
    },
    convertDisplayToISO(displayDate) {
      if (!displayDate || !/^\d{2}\/\d{2}\/\d{4}$/.test(displayDate)) return null;
      const [day, month, year] = displayDate.split('/');
      return `${year}-${month}-${day}`;
    },
    parseDisplayDate(displayDate) {
      const iso = this.convertDisplayToISO(displayDate);
      return iso ? new Date(`${iso}T00:00:00`) : null;
    },
    ensureVigenciaPicker() {
      if (this.vigenciaPicker) return;
      this.initVigenciaPicker();
    },
    initVigenciaPicker() {
      const input = this.$refs.vigenciaInput;
      if (!input) return;
      if (this.vigenciaPicker) {
        this.vigenciaPicker.destroy();
      }
      this.vigenciaPicker = flatpickr(input, {
        dateFormat: DISPLAY_DATE_FORMAT,
        locale: Spanish,
        defaultDate: this.parseDisplayDate(this.modalData.fechaVigencia),
        allowInput: true,
        onChange: (_, dateStr) => {
          this.modalData.fechaVigencia = dateStr || '';
        }
      });
    },
    syncVigenciaPicker() {
      if (!this.vigenciaPicker) {
        this.initVigenciaPicker();
      }
      if (!this.vigenciaPicker) return;
      const dateObj = this.parseDisplayDate(this.modalData.fechaVigencia);
      if (dateObj) {
        this.vigenciaPicker.setDate(dateObj, false, DISPLAY_DATE_FORMAT);
      } else {
        this.vigenciaPicker.clear();
      }
    },
    formateaNumero(n) {
      if (n === null || n === undefined) return '';
      return Number(Math.round(n)).toLocaleString('es-PY', { minimumFractionDigits: 0 });
    },

    // Formateo del input de precio con separador de miles

    clearFilters() {
      this.searchTerm = ''
      this.selectedCategory = ''
      this.selectedCategoryName = ''
      this.categorySearchTerm = ''
      this.priceFilter = this.defaultPriceFilter
      this.stockFilter = this.defaultStockFilter
      this.sourceFilter = 'all'
      this.currentPage = 1
      this.programarCarga()
    }
  },

  watch: {
    // Debounce para búsqueda
    searchTerm: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) this.currentPage = 1
        this.programarCarga({ espera: ESPERA_BUSQUEDA_MS })
      }
    },
    // Cuando cambia la categoría
    selectedCategory(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1
        this.programarCarga()
      }
    },
    priceFilter(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1
        this.programarCarga()
      }
    },
    stockFilter(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1
        this.programarCarga()
      }
    },
    initialSearch: {
      immediate: false,
      handler(newVal) {
        if (!this.selectorMode) return
        const next = String(newVal || '').trim()
        if (next === this.searchTerm) return
        this.searchTerm = next
        this.currentPage = 1
        this.programarCarga()
      }
    }
  },

  mounted() {
    if (this.selectorMode) {
      this.priceFilter = 'true'
      this.stockFilter = 'true'
      this.searchTerm = String(this.initialSearch || '').trim()
    }
    this.programarCarga()
    this.loadCategories()
    this.$nextTick(() => {
      this.initVigenciaPicker();
    })
  },

  beforeUnmount() {
    if (this._cargaProgramada) clearTimeout(this._cargaProgramada)
    if (this.vigenciaPicker) {
      this.vigenciaPicker.destroy();
      this.vigenciaPicker = null;
    }
  }
};
</script>

<style scoped>
.selectable-row {
  cursor: pointer;
}
.selectable-row:hover {
  background-color: #f8f9fa;
}

.page-title-mobile {
  font-size: 1.75rem;
}

.mobile-filter-card {
  border-radius: 18px;
}

.mobile-context-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  margin-bottom: 0.85rem;
  padding: 0.45rem 0.8rem;
  border-radius: 999px;
  background: rgba(15, 23, 42, 0.06);
  color: #0f172a;
}

.mobile-context-label {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #64748b;
}

.mobile-results-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.65rem;
  padding: 0.75rem 0 0.15rem;
  margin-bottom: 0.15rem;
}

.mobile-results-pill {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 0.15rem;
  padding: 0.7rem 0.9rem;
  border-radius: 16px;
  background: #fff;
  border: 1px solid rgba(226, 232, 240, 0.95);
  box-shadow: 0 16px 26px -26px rgba(15, 23, 42, 0.3);
}

.mobile-results-pill.secondary {
  background: #f8fafc;
}

.mobile-results-value {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
}

.mobile-results-value.small {
  font-size: 0.88rem;
}

.mobile-results-copy {
  font-size: 0.74rem;
  letter-spacing: 0.04em;
  color: #64748b;
}

.mobile-product-list {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 14px;
  margin-top: 14px;
  width: 100%;
  min-width: 0;
}

.mobile-product-card {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow: hidden;
  background: #fff;
  border: 1px solid rgba(226, 232, 240, 0.9);
  border-radius: 18px;
  padding: 16px;
  box-shadow: 0 18px 30px -28px rgba(15, 23, 42, 0.28);
}

.mobile-product-top {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 14px;
  align-items: flex-start;
  min-width: 0;
}

.mobile-product-code {
  margin: 0 0 6px;
  font-size: 0.78rem;
  color: #64748b;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.mobile-product-name {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.mobile-price-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  max-width: 100%;
  border-radius: 999px;
  padding: 8px 12px;
  background: rgba(22, 163, 74, 0.12);
  color: #166534;
  font-weight: 700;
  overflow-wrap: anywhere;
  word-break: break-word;
  text-align: center;
}

.mobile-price-badge.empty {
  background: rgba(239, 68, 68, 0.12);
  color: #b91c1c;
}

.mobile-product-meta {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin-top: 14px;
}

.mobile-meta-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
  padding: 10px 12px;
  border-radius: 14px;
  background: #f8fafc;
}

.mobile-meta-item strong {
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.mobile-meta-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #64748b;
}

.mobile-product-actions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-top: 16px;
}

.mobile-product-actions .btn {
  width: 100%;
  min-width: 0;
  white-space: normal;
  overflow-wrap: anywhere;
}

.price-modal-summary {
  margin-bottom: 18px;
  padding: 14px;
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.08), rgba(14, 165, 233, 0.08));
}

.price-modal-eyebrow {
  margin: 0 0 4px;
  font-size: 0.76rem;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #475569;
}

.price-modal-name {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
}

.price-quick-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.price-modal-footer-actions {
  margin-top: 1rem;
}

.price-save-btn {
  min-width: 220px;
}

/* Tabla responsive optimizada */
.table {
  margin-bottom: 0;
  font-size: 0.9rem;
}

.table thead th {
  white-space: nowrap;
  padding: 0.6rem 0.4rem;
  font-size: 0.85rem;
  font-weight: 600;
  vertical-align: middle;
}

.table tbody td {
  padding: 0.5rem 0.4rem;
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
}

.table tbody tr {
  border-bottom: 1px solid #dee2e6;
}

/* Limitar altura del texto largo */
.col-nombre {
  max-width: 150px;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.text-end {
  text-align: right;
}

/* Contenedor de tabla scrollable en pantallas pequeñas */
.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 1366px) {
  .table {
    font-size: 0.85rem;
  }
  .table thead th,
  .table tbody td {
    padding: 0.4rem 0.3rem;
  }
}
</style>
/* Estilos para el dropdown de categorías */
<style scoped>
.category-dropdown { 
  background: white; 
  font-size: 0.9rem;
}
.dropdown-item {
  transition: background-color 0.15s ease-in-out;
  border-bottom: 1px solid #f8f9fa;
  padding: 0.4rem 0.6rem !important;
}
.dropdown-item:last-child { border-bottom: none; }
.dropdown-item:hover,
.hover-bg-light:hover { background-color: #f8f9fa; }
.cursor-pointer { cursor: pointer; }

/* Scrollbar */
.category-dropdown::-webkit-scrollbar { width: 8px; }
.category-dropdown::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 4px; }
.category-dropdown::-webkit-scrollbar-thumb { background: #888; border-radius: 4px; }
.category-dropdown::-webkit-scrollbar-thumb:hover { background: #555; }
</style>
/*    {
        "producto_id": 22,
        "nombre": "prueba",
        "descripcion": "des",
        "stock_disponible": 641,
        "categoria": "Confitería",
        "unidad_medida": "g",
        "precio_venta": 44000,
        "precio_ultima_compra": 70000
    }, */

<style scoped>
.btn-success {
  background-color: #28a745;
  border-color: #28a745;
}

.header-buttons {
  display: flex;
  justify-content: flex-end;
}

/* Column width control to keep layout stable between filter states */
.col-barcode { width: 11%; min-width: 110px; }
.col-nombre { width: 18%; min-width: 140px; }
.col-price-compra { width: 11%; min-width: 105px; }
.col-categoria { width: 12%; min-width: 105px; }
.col-stock { width: 8%; min-width: 85px; }
.col-price { width: 10%; min-width: 90px; }
.col-actions { width: 20%; min-width: 180px; }

/* Ensure action buttons stay on one line and wrap gracefully if very narrow */
.actions-wrapper { 
  white-space: nowrap; 
  gap: 0.3rem !important;
}

.actions-wrapper .btn-sm {
  padding: 0.25rem 0.35rem;
  font-size: 0.7rem;
  line-height: 1;
  white-space: nowrap;
}

@media (max-width: 1200px) {
  .col-actions { width: 22%; }
  .actions-wrapper .btn-sm {
    padding: 0.2rem 0.3rem;
    font-size: 0.65rem;
  }
}
@media (max-width: 992px) {
  .products-price-page {
    overflow-x: hidden;
  }

  .page-header-mobile {
    flex-direction: column;
    align-items: stretch !important;
    gap: 12px;
  }

  .btn-mobile-primary {
    width: 100%;
    justify-content: center;
  }

  .mobile-filter-wrap,
  .mobile-filter-main {
    flex-direction: column;
    align-items: stretch !important;
  }

  .mobile-search-input,
  .mobile-category-picker,
  .mobile-clear-btn {
    width: 100% !important;
    max-width: none !important;
  }

  .mobile-price-filter {
    justify-content: stretch;
  }

  .mobile-price-filter .btn {
    flex: 1 1 0;
  }

  .mobile-results-summary {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .mobile-product-card {
    padding: 14px;
  }

  .mobile-product-top,
  .mobile-product-meta,
  .mobile-product-actions {
    min-width: 0;
  }

  .mobile-product-actions {
    grid-template-columns: 1fr;
  }

  .actions-wrapper { flex-wrap: wrap; white-space: normal; }
  .col-actions { width: 100%; }

  #updatePriceModal .modal-dialog {
    margin: 0;
    min-height: 100vh;
    max-width: 100%;
  }

  #updatePriceModal .modal-content {
    min-height: 100vh;
    border-radius: 0;
  }

  #updatePriceModal .modal-body {
    padding-bottom: 112px;
  }

  .price-quick-actions .btn {
    flex: 1 1 calc(50% - 8px);
  }

  .price-modal-footer-actions {
    position: sticky;
    bottom: -1rem;
    padding: 0.9rem 0 0;
    margin-top: 1.25rem;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0), #fff 28%);
  }

  .price-save-btn {
    width: 100%;
    min-width: 0;
  }
}

@media (max-width: 576px) {
  .container-xl {
    padding-left: 12px !important;
    padding-right: 12px !important;
  }

  .page-title-mobile {
    font-size: 1.25rem;
  }

  .mobile-product-meta {
    grid-template-columns: 1fr;
  }

  .mobile-product-actions {
    grid-template-columns: 1fr;
  }

  .mobile-results-summary {
    grid-template-columns: 1fr;
    margin-bottom: 0.35rem;
  }

  .mobile-product-top {
    grid-template-columns: 1fr;
  }

  .mobile-price-badge {
    justify-self: flex-start;
    max-width: 100%;
    padding-inline: 10px;
  }

  .price-quick-actions {
    flex-direction: column;
  }

  .price-quick-actions .btn {
    width: 100%;
  }
}
</style>
